import { HelpCenterButtonDirective } from './directives/help-center-button.directive';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { PasswordModule } from 'primeng/password';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarModule } from 'primeng/sidebar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { DataViewModule } from 'primeng/dataview';
import { CardModule } from 'primeng/card';
import { RippleModule } from 'primeng/ripple';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { ListboxModule } from 'primeng/listbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { StepsModule } from 'primeng/steps';
import { InputNumberModule } from 'primeng/inputnumber';
import { ChipsModule } from 'primeng/chips';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaceNullWithPipe } from './pipes/replace-null-with.pipe';
import { InputSwitchModule } from 'primeng/inputswitch';
import { OptionsMappingPipe } from './pipes/options-mapping.pipe';
import { CarTypeMappingPipe } from './pipes/car-type-mapping.pipe';
import { CbTypeLabelPipe } from './pipes/cb-type-label.pipe';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload'
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { PickListModule } from 'primeng/picklist';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ToolbarModule } from 'primeng/toolbar';
import { MenubarModule } from 'primeng/menubar';
import { TimelineModule } from 'primeng/timeline';
import { EditorModule } from 'primeng/editor';
import { TabMenuModule } from 'primeng/tabmenu';
import { GalleriaModule } from 'primeng/galleria';
import { TabViewModule } from 'primeng/tabview';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { WebcamModule } from 'ngx-webcam';
import { SearchFormParameterGroupComponent } from './components/search-form-parameter-group/search-form-parameter-group.component';
import { DataTableSettingDirective } from './directives/data-table-setting.directive';
import { ImagePipe } from './pipes/image.pipe';
import { DataTableComponent } from './components/data-table/data-table.component';
import { InputSetComponent } from './components/input-set/input-set.component';
import { TaxOptionsMappingPipe } from './pipes/tax-options-mapping.pipe';
import { TextAreaSetComponent } from './components/text-area-set/text-area-set.component';
import { OpexOrgIdOptionsMappingPipe } from './pipes/opex-org-id-options-mapping.pipe';
import { DataViewComponent } from './components/data-view/data-view.component';
import { ListOptionsMappingPipe } from './pipes/list-options-mapping.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TableColumnToggleComponent } from './components/table-column-toggle/table-column-toggle.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { FileUploadDialogComponent } from './components/file-upload-dialog/file-upload-dialog.component';
import { ToggleValuePipe } from './pipes/toggle-value-pipe.pipe';
import { LoopGroupDecoderPipe } from './pipes/loop-group-decoder.pipe';
import { FormatTimePipe } from './pipes/format-time.pipe';
import { CustomerDropdownComponent } from './components/dropdowns/customer-dropdown/customer-dropdown.component';
import { FacilityDropdownComponent } from './components/dropdowns/facility-dropdown/facility-dropdown.component';
import { TenantOrgDropdownComponent } from './components/dropdowns/tenant-org-dropdown/tenant-org-dropdown.component';
import { TenantDropdownComponent } from './components/dropdowns/tenant-dropdown/tenant-dropdown.component';
import { EmployeeDropdownComponent } from './components/dropdowns/employee-dropdown/employee-dropdown.component';
import { DofilemanagementComponent } from '../features/component/dofile-management/dofile-management.component';
import { AdvanceTaskPipePipe } from './pipes/advance-task-pipe.pipe';
import { AddressManagementComponent } from '../features/component/address-management/address-management.component';
import { SameAddressApplyComponent } from '../features/component/same-address-apply/same-address-apply.component';
import { DofilePodManagementComponent } from '../features/component/dofile-pod-management/dofile-pod-management.component';
import '../core/global';
import { FullToHalfDirective } from './directives/full-to-half.directive';
import { InputComponent } from './components/input/input.component';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { AdvanceTaskMaintenanceComponent } from '../features/component/advance-task-maintenance/advance-task-maintenance.component';
import { PermissionButtonComponent } from './components/permission-button/permission-button.component';
import { CustomRowsPerPageComponent } from './components/custom-rows-per-page/custom-rows-per-page.component';
import { MultipleDofileManagementComponent } from '../features/component/multiple-dofile-management/multiple-dofile-management.component';
import { PatchAccordionInputsDirective } from './directives/patch-accordion-input.directive';
import { LocationCascadeDropdownComponent } from './components/dropdowns/location-cascade-dropdown/location-cascade-dropdown-component';
import { PlantDropdownComponent } from './components/dropdowns/plant-dropdown/plant-dropdown.component';
import { CustomDropdownModule } from './components/dropdowns/custom-dropdown/custom-dropdown.component';
import { CustomMultiSelectModule } from './components/dropdowns/custom-multiSelect/custom-multiSelect.component';
import { RouterModule } from '@angular/router';
import { MenuModule } from 'primeng/menu';
import { HelpCenterDialogComponent } from './components/help-center-dialog/help-center-dialog.component';
import { HelpDockComponent } from './components/help-dock/help-dock.component';
import { LaasEditorComponent } from './components/laas-editor/laas-editor.component';
import { HelpCenterDownloadButtonDirective } from './directives/help-center-download-button.directive';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ColumnFilterComponent } from './components/data-table/column-filter/column-filter.component';

import { TimeSliderComponent } from "./components/calendar/time-slider/time-slider.component";

const primengModules = [
  CalendarModule,
  DropdownModule,
  InputTextModule,
  ButtonModule,
  TableModule,
  ToastModule,
  BlockUIModule,
  ProgressSpinnerModule,
  SidebarModule,
  PanelMenuModule,
  OverlayPanelModule,
  PanelModule,
  DataViewModule,
  CardModule,
  DialogModule,
  RippleModule,
  AccordionModule,
  ListboxModule,
  RadioButtonModule,
  MultiSelectModule,
  CheckboxModule,
  StepsModule,
  InputNumberModule,
  ChipsModule,
  InputSwitchModule,
  ConfirmDialogModule,
  FileUploadModule,
  InputTextareaModule,
  TagModule,
  TooltipModule,
  PickListModule,
  ConfirmPopupModule,
  ToolbarModule,
  MenubarModule,
  PasswordModule,
  TimelineModule,
  EditorModule,
  TabMenuModule,
  GalleriaModule,
  TabViewModule,
  AutoCompleteModule,
  WebcamModule,
  ZXingScannerModule,
  TieredMenuModule,
  // PFluidModule,
  // PFormGridLayoutModule,
  CardModule,
  FormsModule,
  MenuModule,
  CustomMultiSelectModule,
  CustomDropdownModule,
  DynamicDialogModule

];

const laasComponent = [
  TableColumnToggleComponent,
  CalendarComponent,
  FileUploadDialogComponent,
  CustomerDropdownComponent,
  FacilityDropdownComponent,
  TenantOrgDropdownComponent,
  TenantDropdownComponent,
  EmployeeDropdownComponent,
  InputComponent,
  DofilemanagementComponent,
  AddressManagementComponent,
  SameAddressApplyComponent,
  DofilePodManagementComponent,
  AdvanceTaskMaintenanceComponent,
  LocationCascadeDropdownComponent,
  PlantDropdownComponent,
  HelpCenterDialogComponent,
  HelpDockComponent,
  LaasEditorComponent,
];

@NgModule({
  declarations: [
    ReplaceNullWithPipe,
    OptionsMappingPipe,
    CarTypeMappingPipe,
    CbTypeLabelPipe,
    SearchFormParameterGroupComponent,
    DataTableSettingDirective,
    ImagePipe,
    DataTableComponent,
    InputSetComponent,
    TaxOptionsMappingPipe,
    TextAreaSetComponent,
    OpexOrgIdOptionsMappingPipe,
    DataViewComponent,
    ListOptionsMappingPipe,
    SafeHtmlPipe,
    ToggleValuePipe,
    LoopGroupDecoderPipe,
    FormatTimePipe,
    ...laasComponent,
    AdvanceTaskPipePipe,
    FullToHalfDirective,
    PermissionButtonComponent,
    CustomRowsPerPageComponent,
    MultipleDofileManagementComponent,
    PatchAccordionInputsDirective,
    HelpCenterButtonDirective,
    HelpCenterDownloadButtonDirective,
    ColumnFilterComponent,
    TimeSliderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    ...primengModules,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ReplaceNullWithPipe,
    ToggleValuePipe,
    LoopGroupDecoderPipe,
    OptionsMappingPipe,
    CarTypeMappingPipe,
    CbTypeLabelPipe,
    TaxOptionsMappingPipe,
    SearchFormParameterGroupComponent,
    DataTableSettingDirective,
    DataTableComponent,
    ImagePipe,
    InputSetComponent,
    TextAreaSetComponent,
    OpexOrgIdOptionsMappingPipe,
    DataViewComponent,
    ListOptionsMappingPipe,
    SafeHtmlPipe,
    FormatTimePipe,
    ...primengModules,
    ...laasComponent,
    AdvanceTaskPipePipe,
    FullToHalfDirective,
    PermissionButtonComponent,
    CustomRowsPerPageComponent,
    MultipleDofileManagementComponent,
    PatchAccordionInputsDirective,
    RouterModule,
    HelpCenterButtonDirective,
    ColumnFilterComponent,
    HelpCenterDownloadButtonDirective
  ],
  providers: [DialogService],
})

export class LaaSSharedModule { }
